import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { RefreshCw, Clock } from "lucide-react";

const DashboardControls = ({ onRefresh, isLoading, lastUpdated }) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between space-y-4 sm:space-y-0 mb-6">
      <div className="space-y-1">
        <h1 className="text-2xl font-bold text-gray-900">
          {t("dashboard.welcome")}
        </h1>
        <p className="text-gray-600">{t("dashboard.overview")}</p>
      </div>

      <div className="flex flex-col sm:flex-row sm:items-center space-y-3 sm:space-y-0 sm:space-x-4 rtl:sm:space-x-reverse">
        {/* Refresh button */}
        <button
          onClick={onRefresh}
          disabled={isLoading}
          className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 disabled:opacity-50 transition-colors flex items-center space-x-2 rtl:space-x-reverse whitespace-nowrap"
          aria-label={t("dashboard.refreshData")}
        >
          <RefreshCw className={`w-4 h-4 ${isLoading ? "animate-spin" : ""}`} />
          <span>{t("dashboard.refreshData")}</span>
        </button>

        {/* Last updated timestamp */}
        {lastUpdated && (
          <div className="flex items-center space-x-2 rtl:space-x-reverse text-sm text-gray-500">
            <Clock className="w-4 h-4" />
            <span className="whitespace-nowrap">
              {t("dashboard.lastUpdated", {
                time: new Date(lastUpdated).toLocaleTimeString(),
              })}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default DashboardControls;
